import React from "react";
import { ReferenceLine as RL } from "recharts";

export const ReferenceLine: (any) => React.ReactElement = RL;
